import { useEffect } from "react";

import { useMarket } from "#/store/app/portfolio/market";
import { useMaturity } from "#/store/options/page/maturity";

import { useWorker } from "../useWorker";

export function useTrackMaturityAndPair() {
  const { worker, isWorkerReady } = useWorker();
  const { maturity } = useMaturity();
  const { market } = useMarket();

  const marketPair = market.pair;

  useEffect(() => {
    if (!isWorkerReady) return;

    worker!.setValues({
      maturities: [maturity].filter(Boolean),
      marketPair,
    });
  }, [maturity, marketPair, worker, isWorkerReady]);
}
